<form (ngSubmit)="onSubmit()" class="row" [formGroup]="form">
  <div class="form-group col-12">
    <label for="fideicomiso">Fideicomiso:</label>
    <uni-select
      formControlName="escrow"
      [clearable]="false"
      bindLabel="sNombreCorto"
      labelForId="fideicomiso"
      [items]="escrows$ | async"
    >
    </uni-select>
  </div>

  <div class="form-group col-12">
    <label for="area">Área de Solicitud:</label>
    <ng-select formControlName="area" bindLabel="sNombre" labelForId="area" [items]="areas$ | async"></ng-select>
  </div>

  <div class="col-md-12">
    <div class="form-group">
      <label>Tipo de Solicitud:</label>
      <uni-select
        formControlName="type"
        [loading]="types$ | loading | async"
        bindLabel="sNombre"
        [items]="types$ | async"
      ></uni-select>
    </div>
  </div>

  <div class="col-md-12">
    <div class="form-group">
      <label>Subtipo de Solicitud:</label>
      <uni-select
        formControlName="subtype"
        bindLabel="sNombre"
        [loading]="subTypes$ | loading | async"
        [items]="subTypes$ | async"
      ></uni-select>
    </div>
  </div>

  <div class="col-12 text-right pt-3">
    <button type="submit" [disabled]="form.invalid" uni-button uniStepperNext icon="chevron-right">Siguiente</button>
  </div>
</form>
